<script>
    import { onMount, onDestroy } from 'svelte';
    import { userRole } from '../stores/sessionStore';
  
    onMount(() => {});
  
    onDestroy(() => {});
  </script>
  
  <div class="mx-1 mt-3 mb-0 p-4 rounded-lg shadow-md overflow-y-auto relative">
    <div class="absolute inset-0 bg-[url('/title_bg_light.jpg')] dark:bg-[url('/title_bg_dark.jpg')] bg-cover bg-center bg-no-repeat opacity-50 dark:opacity-50"></div>
    <div class="flex gap-3">
      <div class="w-full">
        <img src="/summa-logo-big.png" alt="Logo" class="h-36 mx-auto" />
      </div>
    </div>

    <div class="flex gap-3 mt-4">
        <div class="w-full">
          <div class="text-2xl text-gray-900 dark:text-gray-100 text-center">Welcome to SUMMA Portal</div>
        </div>
    </div>
  
    <div class="flex gap-3 mt-2 mb-80">
      <div class="w-full">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <p class="block text-xs text-gray-900 dark:text-gray-100 opacity-90 text-center">
          Clinical study management made easy by 
          <a href="https://precisiondigitalhealth.com" target="_blank" class="text-gray-900 dark:text-gray-100 font-semibold hover:text-sky-700 dark:hover:text-sky-500">Precision Digital Health Inc.</a>
        </p>
      </div>
    </div>

  </div>